import React, { useState, useContext } from 'react';
import LoginModal from '../../../../../auth/login';
import { AuthContext } from '../../../../../context/AuthContext';
import styles from './LoginButton.module.css';

const LoginButton = () => {
    const [showLoginModal, setShowLoginModal] = useState(false);
    const { isAuthenticated } = useContext(AuthContext);

    const handleLoginClick = () => {
        setShowLoginModal(true);
    };

    // Don't render if user is authenticated
    if (isAuthenticated) {
        return null;
    }

    return (
        <>
            <div className={styles.loginButton}>
                <div className={styles.buttonContainer}>
                    <button
                        className={styles.loginBtn}
                        onClick={handleLoginClick}
                    >
                        <div className={styles.iconContainer}>
                            <div className={styles.iconWrapper}>
                                <div className={styles.iconInner}>
                                    <img
                                        src="https://c.animaapp.com/mhof1dcsmYxOSQ/assets/icon-6.svg"
                                        alt="Login Icon"
                                        className={styles.loginIcon}
                                    />
                                </div>
                            </div>
                        </div>
                        <span className={styles.loginText}>Log In</span>
                    </button>
                </div>
            </div>
            <LoginModal show={showLoginModal} onHide={() => setShowLoginModal(false)} />
        </>
    );
};

export default LoginButton;
